export function initUpcomingEditionsFilter() {
  // Set up filter buttons
  const filterButtons = document.querySelectorAll('.filter-button');
  const allItems = document.querySelectorAll('.filter-list-item');

  // Add click event to each filter button
  filterButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Remove active class from all buttons
      filterButtons.forEach(btn => btn.classList.remove("active"));
      
      // Add active class to current button
      this.classList.add("active");
      
      // Get the season value from the button's data attribute
      const season = this.getAttribute('data-season');
            
      // If "All" is selected, show all items
      if (season === 'all') {
        allItems.forEach(item => {
          item.classList.remove("filtered-out");
      	});
      } else {
      	// Filter items based on the selected season
      	allItems.forEach(item => {
          const itemSeason = item.getAttribute('data-season');
          if (itemSeason === season) {
            item.classList.remove("filtered-out");
         } else {
            item.classList.add("filtered-out");
         }
       });
     }
    });
  });
  
  // Trigger "All" filter on page load
  const allButton = document.querySelector('[data-season="all"]');
  if (allButton) {
    allButton.click();
  }
}